import { getElementComputedStyleFromNode } from "@/lib/canvas/helpers";
import { uiStore } from "@/store/store";
import lodash from "lodash";

export function getSpacingPropertyValue(
  propertyPath: string,
  cssProperty: string
) {
  const valInPx = getCurrentValueInPx(propertyPath, cssProperty);
  return valInPx ? valInPx : 0;
}

export function getCurrentValueInPx(path: string, cssProperty: string) {
  if (!uiStore.activeElement) return false;

  const fullPath = fullPathToSpacingProp(path, uiStore.currentBreakpoint.id);

  let currentValue = parseInt(
    lodash.get(uiStore.activeElement, `data.properties.${fullPath}.number`)
  );

  if (!currentValue) {
    currentValue = 0;
  }

  let currentUnit = lodash.get(
    uiStore.activeElement,
    `data.properties.${fullPath}.unit`
  );

  if (!currentUnit) {
    currentUnit = "px";
  }

  if (currentUnit !== "px" && currentValue !== 0) {
    const computedStyle = getElementComputedStyleFromNode(
      uiStore.activeElement
    );
    if (!computedStyle) return false;

    const styleValue = parseInt(computedStyle.getPropertyValue(cssProperty));

    return styleValue;
  }
  return currentValue;
}

export function fullPathToSpacingProp(path: string, breakpointSlug: string) {
  return path.replace("%%BREAKPOINT%%", breakpointSlug);
}
